import { Component, OnInit } from "@angular/core";
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  Validators,
} from "@angular/forms";
import {
  fileProcessing,
  getFileNameFromUrl,
  onDateChange,
} from "src/app/utils/utils.common";
import { DriversService } from "../drivers-service/drivers-service";
import { imageProcessing } from "src/app/utils/image-processing-utils";
import { ProTipsServiceService } from "../../helping-material/nemt-pro-tips/service/pro-tips-service.service";
import { first, takeUntil } from "rxjs/operators";
import { componentDestroyed } from "@w11k/ngx-componentdestroyed";
import { ActivatedRoute, Router } from "@angular/router";

@Component({
  selector: "app-driver-credentials",
  templateUrl: "./driver-credentials.component.html",
  styleUrls: ["./driver-credentials.component.css"],
})
export class DriverCredentialsComponent implements OnInit {
  credentialsForm: FormGroup;
  selectedDate;
  isSubmitted = false;
  documents;

  constructor(
    private fb: FormBuilder,
    private driverService: DriversService,
    private proTips: ProTipsServiceService,
    private activated : ActivatedRoute,
    private router : Router
  ) {}

  ngOnInit() {
    this.credentialsForm = this.fb.group({
      driver: [""],
      license: this.fb.group({
        imageURL: [""],
        licenseNumber: ["", Validators.required],
        isRequired: [false],
        preIssueDate: [""],
        preExpiryDate: [""],
        issueDate: ["",Validators.required],
        expiryDate: ["",Validators.required],
      }),
      vehicleRecord: this.getFormGroup(),
      standardCheck: this.getFormGroup(),
      vehicleInspection: this.getFormGroup(),
      drivingRecord: this.getFormGroup(),
      criminalCheck: this.getFormGroup(),
      offenderCheck: this.getFormGroup(),
      criminalRecord: this.getFormGroup(),
      liveScan: this.getFormGroup(),
      liveScanDOJ: this.getFormGroup(),
      policeClearance: this.getFormGroup(),
      fingerPrint: this.getFormGroup(),
      drugTest: this.getFormGroup(),
      drugVerification: this.getFormGroup(),
      alcoholScreening: this.getFormGroup(),
      alcoholVerification: this.getFormGroup(),
      tbTest: this.getFormGroup(),
      fluVaccine: this.getFormGroup(),
      fluVaccineDeclined: this.getFormGroup(),
      covidVaccine: this.getFormGroup(),
      covidVaccineDeclined: this.getFormGroup(),
      dotPhysicalExam: this.getFormGroup(),
      accidentTraining: this.getFormGroup(),
      handsFree: this.getFormGroup(),
      emergencyTraining: this.getFormGroup(),
      harrassmentTraining: this.getFormGroup(),
      elderAbuse: this.getFormGroup(),
      smokeFree: this.getFormGroup(),
      attestation: this.getFormGroup(),
      hippaTraining: this.getFormGroup(),
      defensiveDriving: this.getFormGroup(),
      pathogenTraining: this.getFormGroup(),
      assisstanceTraining: this.getFormGroup(),
      wheelchairTraining: this.getFormGroup(),
      gurneyTraining: this.getFormGroup(),
      complianceTraining: this.getFormGroup(),
      cprStartDate: this.getFormGroup(),
      cprExpiryDate: this.getFormGroup(),
      roadTraining: this.getFormGroup(),
      competencyAssessment: this.getFormGroup(),
      oigScreening: this.getFormGroup(),
      samScreening: this.getFormGroup(),
      completionCertificate: this.getFormGroup(),
      complianceAcknowledge: this.getFormGroup(),
    });
    this.activated.params
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((params) => {
      const driver = params["id"];
      this.credentialsForm.patchValue({
        driver
      });
      this.getDocumentsbyId(driver)
    });
  }

  getFormGroup(): AbstractControl {
    return this.fb.group({
      imageURL: [""],
      isRequired: [false],
      preDate: [""],
      date: [""],
      acknowledgement: [false],
    });
  }

  getDocumentsbyId(driverId){
    this.driverService.getDocumentsbyId(driverId)
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe((data) =>{
      if(data){
        this.documents = data;
        const keys: any = this.formKeys()
        keys.forEach(key => {
          this.credentialsForm.patchValue({
            license : {
              imageURL : data.license.imageURL,
              licenseNumber : data.license.licenseNumber,
              preIssueDate : data.license.issueDate,
              preExpiryDate : data.license.expiryDate,},
            [key] : {
              ...data[key],
              preDate: data[key].date
            }
          });
        });
      }
    })
  }

  onChangeToggle(control: AbstractControl) {
    control.setValue(!control.value);
  }

  async fileProcessing(ImageInput, form) {
  imageProcessing(ImageInput)
   .subscribe(async (result) => {
    const data:any =  await this.proTips.changeCoverImage(result.file).toPromise();
    form.setValue(data.location);
  })

  }


  getFileName(url) {
    return getFileNameFromUrl(url);
  }

  onDateChange(event, control) {
    onDateChange(event, control);
  }

  formKeys(){
    const formGroupNames = Object.keys(this.credentialsForm.controls);
    const filteredFormGroupNames = formGroupNames.filter(key => key !== 'license' && key !=="driver");
      return filteredFormGroupNames

  }

  get form() {
    return this.credentialsForm.controls;
  }

  onSubmit() {
    this.isSubmitted = true;
    if (this.credentialsForm.invalid) {
      return;
    }

    const docId = this.documents? this.documents._id : null
    this.driverService
      .addDocuments(this.credentialsForm.value,  docId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.router.navigateByUrl("credentialing/drivers");
        }
      });
  }
  ngOnDestroy(): void {}
}
